export default __webpack_public_path__ + "static/media/viewarrow.db7b8a71.svg";